import styled from '@emotion/styled';
import { RichDropdownMenu } from '@liveoptics/react-ui';
import React, { FormEvent, useCallback } from 'react';
import { OpportunityMode } from '../../../enums';

export interface OpportunityModeDropDownMenuProps {
  defaultValue?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

const StyledDropDownMenu = styled(RichDropdownMenu)`
  width: 100% !important;
  ul {
    max-height: 125px !important;
  }
`;

export const OpportunityModeDropDownMenu = (props: OpportunityModeDropDownMenuProps) => {
  const handleChange = useCallback(
    (option: FormEvent<HTMLDivElement> & { value: string; label: string }) => {
      if (props.onChange) {
        props.onChange(option.value);
      }
    },
    [props]
  );

  const opportunies = [
    {
      value: '-1',
      label: 'Select Reason',
      disabled: true,
    },
    {
      value: OpportunityMode.DiscoveryPhase,
      label: 'Discovery',
      disabled: false,
    },
    {
      value: OpportunityMode.TroubleShooting,
      label: 'Troubleshooting',
      disabled: false,
    },
    {
      value: OpportunityMode.Other,
      label: 'Other',
      disabled: false,
    },
  ];
  return (
    <StyledDropDownMenu
      placeholder="Select Reason"
      disabled={props.disabled}
      value={
        props.defaultValue && props.defaultValue !== OpportunityMode.None
          ? props.defaultValue
          : '-1'
      }
      onChange={handleChange}
      options={opportunies}
    ></StyledDropDownMenu>
  );
};
